// TODO: this maybe be moved the API app

export const TENANTS = {
  PSM: 'psm',
  SHELFLIFE: 'shelflife',
  MEDBURY: 'medbury',
  EPN: 'epn'
}
